import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from 'nuvo-react'

export const dropzone: ThemeAPI['dropzone'] = {
  root: {
    backgroundColor: theme.colors.grey000White,
    border: theme.border.width.s1,
  },
  icon: {
    box: {
      fill: theme.colors.iconPrimary,
    },
  },
  content: {
    root: {
      backgroundColor: theme.colors.grey000White,
      border: `${theme.border.width.s1} ${theme.border.style.solid} ${theme.border.color.grey400}`,
      borderRadius: theme.dimensions.s20,
      padding: `${theme.dimensions.s20} ${theme.dimensions.s32}`,
    },
    title: {
      color: theme.colors.grey1000,
    },
    description: {
      color: theme.colors.grey700,
    },
    illustration: {
      borderColor: theme.colors.radicalRed200,
      headerColor: theme.colors.radicalRed200,
      circleHeaderColor: theme.colors.radicalRed400,
      circleRowColor: theme.colors.radicalRed100,
      downloadIconColor: theme.colors.radicalRed800,
      shadowColor: theme.colors.radicalRed050,
    },
  },
  container: {
    padding: theme.dimensions.s0,
  },
}
